angular.module('bmsApp.dashboard').factory('SharedTrainingSvc', function ($rootScope, CRUDSvc, $modal) {
	return {

		index: function (params) {
			return CRUDSvc.get('api/shared-training/index', params);
		},

		shareIndex: function (params) {
			return CRUDSvc.get('api/shared-training/share/index', params);
		},

		saveShare: function(params) {
			return CRUDSvc.post('api/shared-training/share/save', params);
		},

		deleteShare: function(params) {
			return CRUDSvc.post('api/shared-training/share/delete', params);
		},

		updateDueDate: function(params) {
			return CRUDSvc.post('api/shared-training/update-due-date', params);
		},

		toggleDisabled: function(params) {
			return CRUDSvc.post('api/shared-training/toggle-disabled', params);
		},

		setAsComplete: function(params) {
			return CRUDSvc.post('api/shared-training/set-as-complete', params);
		},

		startRefresher: function(params) {
			return CRUDSvc.post('api/shared-training/start-refresher', params);
		},

		showShareModal: function(item) {
			let  modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/dashboard/templates/TrainingShareModal.html',
				controller: 'TrainingShareModalCtrl',
				controllerAs: 'TrainingShare',
				resolve: {
					item: function () {
						return angular.copy(item);
					},
				},
				size: 'md',
				scope: $rootScope,
				backdrop: 'static', // disable click-outside closing modal
			});

			return modalInstance.result;
		},

		showTrainingModal: function(userCourse) {
			let  modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/dashboard/templates/TrainingModal.html',
				controller: 'TrainingModalCtrl',
				controllerAs: 'TrainingModal',
				resolve: {
					userCourse: function () {
						return angular.copy(userCourse);
					},
				},
				size: 'md',
				scope: $rootScope,
				backdrop: 'static', // disable click-outside closing modal
			});

			return modalInstance.result;
		},


	}
});



